import React from 'react';
import { useCallback, useMemo, useState, useEffect } from 'react';
import { getOrgId } from "../../../utils/Token";
import axios from "../../../utils/fvAxios";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import DeleteIcon from '@mui/icons-material/Delete';
import DialogTitle from "@mui/material/DialogTitle";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DialogActions, Dialog, Button, Box ,Tooltip} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import { useDropzone } from 'react-dropzone';
import Logo from '../../../Media/Upload.jpeg';
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import ReplayIcon from '@mui/icons-material/Replay';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#F2F4F7",
        color: "#101828",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
export default function EmployeeDocuments() {
    const [EmailtemplateLists, setEmailtemplateLists] = useState([]);
    const [detailsLists, setdetailLists] = useState();
    const [refresh, setRefresh] = React.useState(true);
    const [spinner, setSpinner] = React.useState(false);
    const [Deletion, SetDeletion] = React.useState('');
    const SpinnerClose = () => {
        setSpinner(false);
    };

    useEffect(() => {
        axios.get("Employee/EmployeeDocuments"
        ).then((res) => {
            if (res?.data) {
                setEmailtemplateLists(res?.data?.data?.empDocs);
                setdetailLists(res?.data?.data)
            } else {
                console.log((res?.data?.data));
            }

        }).finally(() => {
            setRefresh(false)
        })



    }, [refresh]);
    const [isDownloading1, setIsDownloading1] = useState(false);
    const DownloadTraingGuide1 = (r) => {
        setIsDownloading1(true);
        debugger;

        axios.get("Employee/DownloadEmpDoc?idAsFileName=" + r.documentId + "&userEnteredFilename=" + r.docName + "&vendorId=" + r.vendorId, { responseType: "arraybuffer" })
            .then((res) => {
                if (res?.data?.type == "application/json") {
                    toast.error("File not found", {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                } else {
                    setIsDownloading1(false);

                    const blob = new Blob([res.data], { type: res.headers['content-type'] });
                    const dataUrl = URL.createObjectURL(blob);
                    var a=window.open(dataUrl, '_blank');
//a.document.title="fdasfas.pdf";
                    // const downloadLink  = document.createElement('a')

                    // const dataUrl = URL.createObjectURL(blob);

                    // downloadLink.href=dataUrl

                    // downloadLink.download="test.pdf"

                    // document.body.removeChild(downloadLink)

                    // URL.revokeObjectURL(dataUrl)

                    // const downloadLink = document.createElement('a');

                    // // Create an object URL for the Blob
                    // const objectURL = URL.createObjectURL(blob);

                    // // Set the href attribute of the download link to the object URL
                    // downloadLink.href = objectURL;

                    // // Specify the filename for the download
                    // downloadLink.download = 'example.Pdf'; // You can set any filename here

                    // // Append the download link to the body
                    // document.body.appendChild(downloadLink);

                    // // Trigger a click on the download link to open the file in a new window
                    // downloadLink.click();

                    // // Remove the download link from the DOM
                    // document.body.removeChild(downloadLink);

                    // // Revoke the object URL to free up resources
                    // URL.revokeObjectURL(objectURL);




                }
            }).finally(() => {
                setIsDownloading1(false);
            });
    };


    const { t } = useTranslation();
    const [files, setFiles] = useState([]);
    const [fileReset, setFileReset] = useState(true);


    const activeStyle = {
        borderColor: '#2196f3'
    };

    const acceptStyle = {
        borderColor: '#00e676'
    };

    const rejectStyle = {
        borderColor: '#ff1744'
    };
    const onDrop = useCallback((acceptedFiles) => {

        const pdfFiles = acceptedFiles.filter((file) => file.type === 'application/pdf');

        if (pdfFiles.length > 0) {

            setFiles(
                pdfFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                )
            );
        } else {

            alert('Please drop only PDF files.');
            setFiles([]);
        }
    }, []);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({
        onDrop,
        accept: '.pdf',
        maxFiles: 1
    });

    const style = useMemo(() => ({

        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);

    const thumbs = files.map(file => (
        <div key={file.name}>
            {file.name}
        </div>
    ));
    // clean up
    useEffect(() => () => {
        files.forEach(file => URL.revokeObjectURL(file.name));
    }, [fileReset]);
    const [openpop, setOpenpop] = React.useState(false);
    const [type, setType] = React.useState();
    const [replace, setreplace] = React.useState();



    const handleClickOpenpop = (e) => {
        SetDeletion(e)
        setOpenpop(true);
    };

    const handlePopClose = () => {
        setOpenpop(false);
        setFileReset('')
    };
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = (e, r) => {
        setOpen(true);
        setType(e);
        setreplace(r);
    };

    const handleClose = () => {
        setOpen(false);
        setFiles([]);
        //   setEmail('')
    };
    const handleSubmit = (event) => {
        setSpinner(true);
        setOpen(false);
        event.preventDefault();

        const formData = new FormData();
        if (type == 1) {

            formData.append('UserId', detailsLists.userId);
            formData.append('vendorId', detailsLists.vendorId);
            formData.append('pdfFile', files[0]);
        }
        else if (type == 2) {

            formData.append('UserId', replace.userId);
            formData.append('DocumentId', replace.documentId);
            formData.append('VendorId', replace.vendorId);
            formData.append('docName', replace.docName);
            formData.append('UploadedOn', replace.uploadedOn);

            formData.append('pdfFile', files[0]);
        }
        axios
            .post("Employee/AddEmployeeDocument", formData
            )
            .then((res) => {
                if (res?.data?.responseMessage == "Success") {
                    toast.success(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setRefresh(!refresh);
                  
                    setFiles([]);
                } else {
                    toast.error(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setSpinner(false);
            });
    };
    const handleDelete = () => {
        setSpinner(true);
     
        const data = {
            documentId: Deletion?.documentId,
            vendorId: Deletion?.vendorId,
        };

        setOpenpop(false);
        axios
            .post("Employee/DeleteEmployeeDocument", data
            )
            .then((res) => {
                if (res?.data?.responseMessage == "Success") {
                    toast.success(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setRefresh(!refresh);
                    //   setEmail("")
                } else {
                    toast.error(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setSpinner(false);
            });


    };
    return (
        <>

            <Dialog
                open={openpop}
                keepMounted
                onClose={handlePopClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle> {"Are you sure? you want to permanently delete this content? This operation is irreversible."}</DialogTitle>
                <DialogContent>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handlePopClose}>{"Cancel"}</Button>
                    <Button onClick={handleDelete}>{'Yes, delete'}</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

                <DialogContent >
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        <span style={{ fontSize: "larger" }} >{type == 2 ? "Replace the Document" : "Add New Document"}</span>
                    </DialogTitle>


                    <div>
                        <div className="drop" {...getRootProps({ style })} >
                            <img className='mt-2' src={Logo} alt="" />
                            <br />
                            <input className="mt-2" {...getInputProps()} accept=".pdf" />

                            <span className='text-muted mt-2 fs'><b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}{" or drag and drop"}</span>
                                { }</b></span>
                            <br />
                            <span className=' text-muted Fs'>
                                {t('Only Pdf Allowed')} <span style={{ color: "red" }}>*</span></span>
                            <span className=' text-muted Fs'> {thumbs}</span>
                        </div>


                        <DialogActions >
                            <div className="login-help__buttonContainer mt-4">
                                <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                                {/* <Button variant="contained" className="login-button-request mx-2" onClick={handleSubmit} disabled={!files[0]}>Add</Button> */}
                                {!files[0]  ? (
                <Tooltip title="All the fields are mandatory" followCursor>
                  <span>
                  <Button variant="contained" className="login-button-request mx-2" onClick={handleSubmit} disabled={!files[0]}>Add</Button>
                  </span>
                </Tooltip>
              ) : (
                <Button variant="contained" className="login-button-request mx-2" onClick={handleSubmit} >Add</Button>
              )}
                            </div>

                        </DialogActions>
                    </div >

                </DialogContent>
            </Dialog>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner || isDownloading1 || refresh}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <ToastContainer />

            <Box sx={{ padding: "20px" }}>
                <span style={{ fontSize: "28px", fontWeight: "600", color: "#101828" }}>
                    Documents
                </span>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                        "& hr": { mx: 0.5 },
                        marginBottom: "10px"
                    }}
                >
                    <span
                        style={{
                            marginRight: "auto",
                            textDecoration: "none",
                            marginTop: "10px",
                            marginBottom: "10px",
                            color: "#3E4A62",
                        }}
                    >

                    </span>
                    <Button variant="contained" onClick={() => handleClickOpen(1)} sx={{ padding: "10px", textTransform: "capitalize" }}>
                        Upload Documents
                    </Button>
                </Box>
            </Box>
            <TableContainer >

                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Document Name</StyledTableCell>
                            <StyledTableCell align="right">Uploaded On</StyledTableCell>
                            <StyledTableCell align="right">&nbsp;</StyledTableCell>
                            <StyledTableCell align="right">&nbsp;</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {EmailtemplateLists?.map((row, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell component="th" scope="row">
                                    <a onClick={() => DownloadTraingGuide1(row)} style={{ color: "#2A93DB", cursor: "pointer" }}>  {row?.docName}</a>
                                </StyledTableCell>
                                <StyledTableCell align="right" >{GetfVDateFormate(row?.uploadedOn)}</StyledTableCell>
                                <StyledTableCell align="right" onClick={() => handleClickOpen(2, row)}> <div style={{ color: "#667085", cursor: "pointer" }}><ReplayIcon /> Replace</div></StyledTableCell>
                                <StyledTableCell align="right"><DeleteIcon sx={{ color: "#667085", cursor: "pointer" }} onClick={() => handleClickOpenpop(row)} /></StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}
